import { lazy } from 'react';
export const HotFoundPageAsync = lazy(() => import('./HotFoundPage'));
